import { create } from 'zustand';
import { subscriptionApi } from '@/api/subscriptions';
import type { UserSubscription } from '@/types/subscription';

interface SubscriptionState {
  currentSubscription: UserSubscription | null;
  loaded: boolean;

  loadCurrentSubscription: () => Promise<void>;
  setCurrentSubscription: (sub: UserSubscription | null) => void;
  invalidate: () => void;
}

export const useSubscriptionStore = create<SubscriptionState>((set, get) => ({
  currentSubscription: null,
  loaded: false,

  loadCurrentSubscription: async () => {
    if (get().loaded) return;
    try {
      const subscription = await subscriptionApi.getCurrentSubscription();
      set({ currentSubscription: subscription, loaded: true });
    } catch {
      set({ currentSubscription: null, loaded: true });
    }
  },

  setCurrentSubscription: (sub) => set({ currentSubscription: sub, loaded: true }),

  invalidate: () => set({ loaded: false }),
}));
